// @ts-check

import { get, getAll } from "../utilities/querySelector";

const sections = getAll( '.hero-banner' );

export const has_pointer_query = window.matchMedia( "(hover: hover) and (pointer: fine)" );

if ( sections.length > 0 && has_pointer_query.matches ) {
  sections.forEach( section => {
    const buttons = getAll( '.button', section );
    const images = getAll( 'img', section );

    // If there's not a match of buttons to images, we'll just assume there's no mapping
    if ( images.length !== buttons.length ) return;

    // Accounts for the initially applied animation to the hero images.
    // Applying the classes during the animation breaks the transitions, so we first wait for the initial animation to finish
    images[0].addEventListener( 'animationend', setUpMouseImageHoverMap, { once: true } );

    function setUpMouseImageHoverMap() {
      for ( let i = 0; i < images.length; i++ ) {
        buttons[i].addEventListener( 'mouseenter', () => {
          images.forEach( image => ( image === images[i] ) ? image.classList.add( 'active' ) : image.classList.add( 'inactive' ) );
        } );
        buttons[i].addEventListener( 'mouseleave', () => {
          images.forEach( image => ( image === images[i] ) ? image.classList.remove( 'active' ) : image.classList.remove( 'inactive' ) );
        } );
      }
    }

  } );
}